export const ABS_SITE_URL = 'https://www.absolutins.ru/'

export * from './isn'
